import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

function getStatusColorById(theme) {
  return {
    'waiting-analysis': (theme.vars || theme).palette.warning.main,
    analysis: (theme.vars || theme).palette.error.main,
    report: theme.palette.mode === 'light' ? '#7E57C2' : '#B39DDB',
    finalized: (theme.vars || theme).palette.success.main,
  };
}

function MonitoringQuantityChart({ title, description, variation, value, labels, transactions }) {
  const theme = useTheme();
  const statusColorById = getStatusColorById(theme);
  const colorPalette = transactions.map(
    (transaction) => statusColorById[transaction.id] || (theme.vars || theme).palette.primary.main,
  );

  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          {title}
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: 'center', sm: 'flex-start' },
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="h4" component="p">
              {value}
            </Typography>
            <Chip size="small" color="error" label={variation} />
          </Stack>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {description}
          </Typography>
        </Stack>
        <BarChart
          borderRadius={1}
          colors={colorPalette}
          xAxis={[
            {
              scaleType: 'band',
              categoryGapRatio: 0.5,
              // data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],// Choose dinamic last months
              data: labels,
              height: 24,
            },
          ]}
          yAxis={[{ width: 50 }]}
          series={transactions.map((transaction, index) => (
            {
              id: transaction.id,
              label: transaction.label,
              data: transaction.quantity,
              stack: 'A',
            }
          ))}
          height={250}
          margin={{ left: 0, right: 0, top: 20, bottom: 0 }}
          grid={{ horizontal: true }}
          sx={{
            '& .MuiBarElement-root': {
              fillOpacity: 0.5,
            },
          }}
          // hideLegend
        />
      </CardContent>
    </Card>
  );
}

MonitoringQuantityChart.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  transactions: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default MonitoringQuantityChart;
